import standardisePrice from '../../../../../../util/standardisePrice';
import { ISearchAndFilterProduct, ISearchAndFilterProductPrice } from '../../../../types';
import { Product } from '@apptus/esales-api'
import getProductPrice from '../getProductPrice';
import handleFromUrl from '../../../../../../util/handleFromUrl';
import generateTicket from '../handleTickets';

import { PageMeta } from '../../types';

const mapPredSearchProduct = (
  product: Product,
  pageMeta: string,
  contextualPriceData?: {
    price: { amount: string, currencyCode: string },
    compareAtPrice: { amount: string, currencyCode: string } | null,
    priceRange: any
  }
): ISearchAndFilterProduct => {
  const metaObj: PageMeta = {
    pageType: 'quicksearch',
    resourceType: 'quicksearch',
    resourceId: `quicksearch-${pageMeta}`
  }

  generateTicket(product, metaObj);

  // Default to Voyado prices
  let sellingPriceMin = product.sellingPrice.min;
  let sellingPriceMax = product.sellingPrice.max;
  let listPriceMin = product.listPrice.min;
  let listPriceMax = product.listPrice.max;

  // If contextual prices are available (from Storefront API), use them instead
  if (contextualPriceData) {
    if (contextualPriceData.priceRange) {
      sellingPriceMin = parseFloat(contextualPriceData.priceRange.minVariantPrice.amount);
      sellingPriceMax = parseFloat(contextualPriceData.priceRange.maxVariantPrice.amount);
    } else if (contextualPriceData.price) {
      sellingPriceMin = parseFloat(contextualPriceData.price.amount);
      sellingPriceMax = parseFloat(contextualPriceData.price.amount);
    }

    if (contextualPriceData.compareAtPrice) {
      const cap = parseFloat(contextualPriceData.compareAtPrice.amount);
      listPriceMin = cap;
      listPriceMax = cap;
    } else {
      listPriceMin = sellingPriceMin;
      listPriceMax = sellingPriceMax;
    }
  }

  const priceObj: ISearchAndFilterProductPrice = getProductPrice(
    sellingPriceMin,
    sellingPriceMax,
    listPriceMin,
    listPriceMax
  );

  return {
    available: product.inStock,
    handle: handleFromUrl(product.link),
    variants: product.variants.map(variant => ({
      available: variant.inStock,
      compare_at_price: standardisePrice(variant.sellingPrice),
      id: parseInt(variant.key),
      inventory_quantity: variant.stockNumber,
      price: standardisePrice(variant.listPrice)
    })),
    id: parseInt(product.key),
    title: product.title,
    url: product.link,
    // We only want the first (square) image
    images: product.imageInfo.images.flatMap(source => source.sources[0]).slice(0, 1).map(img => ({
      src: img.url,
      alt: product.title,
      width: img.width,
      height: img.height
    })),
    price: standardisePrice(product.sellingPrice.min),
    priceObj: priceObj,
    ticket: product.ticket
  };
};

export default mapPredSearchProduct;
